export default function getNextSalaryDate (day) {
    if (day < 1 || day > 31) {
        throw new Error("Day must be between 1 and 31.");
    }

    const today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();

    if (today.getDate() > day) {
        // If today's date is past the given day, predict the next month
        month += 1;
        if (month > 11) {
            month = 0;
            year += 1;
        }
    }

    const salaryDate = new Date(year, month, day);

    const monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ];

    const getOrdinalSuffix = (n) => {
        if (n > 3 && n < 21) return 'th'; // for 11th, 12th, 13th, etc.
        switch (n % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const formattedDate = `${salaryDate.getDate()}${getOrdinalSuffix(salaryDate.getDate())} ${monthNames[salaryDate.getMonth()]}, ${salaryDate.getFullYear()}`;
    return formattedDate;
};

export const getOrdinalSuffix = (n) => {
    if (n > 3 && n < 21) return 'th'; // for 11th, 12th, 13th, etc.
    switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
};
